import React from 'react'
import { Link, Redirect, useParams } from 'react-router-dom'
import Header from '../user-home-page/Header'
import { Footer } from '../user-home-page/Footer'
import { FloatingActions } from '../user-home-page/FloatingActions'
import { buildSiteUrl, usePageSeo } from 'src/helpers/usePageSeo'
import { breadcrumbSchema } from 'src/helpers/seoStructuredData'
import { getNewsArticleBySlug } from './newsData'
import { ArticleLayout, ArticleMeta, KeywordList, NewsMain, NewsPageWrapper, TakeawayBox } from './News.styles'

const NewsDetailPage: React.FC = () => {
   const { slug } = useParams<{ slug: string }>()
   const article = getNewsArticleBySlug(slug)

   usePageSeo({
      title: article?.title || 'Tin tức xe ghép Thanh Hóa Hà Nội',
      description:
         article?.description ||
         'Tin tức và kinh nghiệm đặt xe ghép Thanh Hóa Hà Nội, gửi hàng trong ngày và chọn chuyến đi phù hợp.',
      path: article ? `/news/${article.slug}` : '/news',
      ogType: article ? 'article' : 'website',
      keywords: article?.keywords,
      structuredData: article
         ? [
              {
                 '@context': 'https://schema.org',
                 '@type': 'Article',
                 headline: article.title,
                 description: article.description,
                 image: buildSiteUrl(article.image),
                 datePublished: article.publishedAt,
                 dateModified: article.updatedAt,
                 inLanguage: 'vi-VN',
                 articleSection: article.category,
                 author: {
                    '@type': 'Organization',
                    name: 'LinhLinh36'
                 },
                 publisher: {
                    '@type': 'Organization',
                    name: 'Xe ghép Thanh Hóa - Hà Nội',
                    logo: {
                       '@type': 'ImageObject',
                       url: buildSiteUrl('/favicon.ico')
                    }
                 },
                 mainEntityOfPage: buildSiteUrl(`/news/${article.slug}`),
                 keywords: article.keywords.join(', ')
              },
              breadcrumbSchema([
                 { name: 'Trang chủ', path: '/' },
                 { name: 'Tin tức', path: '/news' },
                 { name: article.title, path: `/news/${article.slug}` }
              ])
           ]
         : undefined
   })

   if (!article) return <Redirect to="/news" />

   return (
      <NewsPageWrapper>
         <Header />
         <NewsMain>
            <ArticleLayout>
               <Link to="/news">← Tin tức</Link>
               <h1>{article.title}</h1>
               <ArticleMeta>
                  <span>{article.category}</span>
                  <span>{article.readTime}</span>
                  <span>Cập nhật {article.updatedAt}</span>
               </ArticleMeta>
               <p>{article.intro}</p>
               <img src={article.image} alt={article.title} />
               <KeywordList>
                  {article.keywords.map((keyword) => (
                     <span key={keyword}>{keyword}</span>
                  ))}
               </KeywordList>

               {article.sections.map((section) => (
                  <section key={section.heading}>
                     <h2>{section.heading}</h2>
                     {section.body.map((paragraph) => (
                        <p key={paragraph}>{paragraph}</p>
                     ))}
                  </section>
               ))}

               <TakeawayBox>{article.takeaway}</TakeawayBox>
            </ArticleLayout>
         </NewsMain>
         <Footer />
         <FloatingActions />
      </NewsPageWrapper>
   )
}

export default NewsDetailPage
